<template>
  <div>
    <page-title
      heading="Manajemen Obat & BHP"
      :breadcrumb="[
        {
          label: 'Manajemen Obat & BHP',
          link: '/klinik/obat'
        },
        {
          label: 'List Obat',
          active: true
        }
      ]"
      class="layout-gantung ninja-shadow"
    />

    <div class="container-fluid ">
      <div class="ml-4 mb-3">
        <b-button
          variant="outline-primary"
          class="align-self-end font-weight-bold mr-2"
          :to="{
            name: 'klinik-obat-list'
          }"
          style="border-radius:0.65rem"
        >
          Obat
        </b-button>
        <b-button
          variant="outline-dark"
          class="align-self-end font-weight-bold"
          :to="{
            name: 'klinik-list-bhp'
          }"
          style="border-radius:0.65rem"
        >
          Bahan Habis Pakai
        </b-button>
      </div>
      <div id="obat-klinik" class="card card-box ninja-shadow">
        <div class="card-body __zoom_display">
          <b-col md="12">
            <DataTableWrapper
              :perPage="perPage"
              :fromPage="fromPage"
              :toPage="toPage"
              :totalEntries="totalEntries"
              :currentPage="currentPage"
              :callbackFunc="fetchListObat"
              @valueChanged="handleValueChanged"
            >
              <template v-slot:right-header>
                <b-button
                  v-if="hasFeatures('download')"
                  variant="danger"
                  class="text-uppercase align-self-end mr-3"
                  @click="downloadOBAT"
                >
                  <font-awesome-icon icon="download" />
                  Download data
                </b-button>
                <b-button
                  v-if="hasFeatures('upload')"
                  variant="success"
                  class="text-uppercase align-self-end mr-3"
                  @click="goUpload"
                >
                  <font-awesome-icon icon="upload" />
                  upload data
                </b-button>
                <b-button
                  v-if="hasFeatures('tambah_obat')"
                  variant="primary"
                  class="text-uppercase align-self-end"
                  :to="{
                    name: 'klinik-obat-tambah'
                  }"
                  >tambah obat</b-button
                >
              </template>
              <b-table
                :items="obatList"
                :fields="fieldList"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                thead-tr-class="izd-datatable"
                :no-local-sorting="true"
              >
                <!-- HEADER SLOT -->
                <template v-slot:head()="data">
                  {{ data.label }}
                  <b-input
                    size="sm"
                    class="mt-2 w-95"
                    v-if="data.field.searchable"
                    @input="searchValueChanged($event, data.field.key)"
                  />
                </template>

                <template v-slot:head(id)="{}">
                  <div class="bg-cst-box">
                    <b-form-checkbox
                      class="cst-cbox"
                      v-model="selectedAll"
                      @input="isSelectedAll = true"
                    ></b-form-checkbox>
                  </div>
                </template>

                <template v-slot:head(action)="data">
                  <span class="mt-2">{{ data.label }}</span>
                </template>



                <!-- CELL SLOT -->
                <template v-slot:cell(id)="data">
                  <b-form-checkbox
                    v-model="selectedId"
                    :value="data.item.id"
                    @input="isSelectedAll = false"
                  ></b-form-checkbox>
                </template>

                <template v-if="satusehatAuthValid" v-slot:cell(kfa_code)="data">
                  <div class="text-center">
                    <span v-if="data.item.kfa_code">{{ data.item.kfa_code }}</span>
                    <span v-else>-</span>
                  </div>
                </template>

                <template v-if="satusehatAuthValid" v-slot:cell(bentuk_sediaan)="data">
                  <div class="text-center">
                    <span v-if="data.item.bentuk_sediaan">{{ data.item.bentuk_sediaan }}</span>
                    <span v-else>-</span>
                  </div>
                </template>

                <template v-slot:cell(tarif)="data">
                  <div style="display: flex; justify-content: space-between">
                    <span>Rp{{ data.item.tarif | currency }}</span>
                  </div>
                </template>

                <template v-slot:cell(stok)="data">
                  <div class="text-center">
                    <span v-if="data.item.stok == null">-</span>
                    <span v-else>{{ data.item.stok }}</span>
                  </div>
                </template>

                <template v-slot:cell(satuan)="data">
                  <div class="text-center">
                    <span v-if="data.item.satuan == null">-</span>
                    <span v-else>{{ data.item.satuan }}</span>
                  </div>
                </template>

                <template v-slot:cell(action)="data">
                  <span
                    class="d-flex align-items-center justify-content-between"
                  >
                    <b-dropdown
                      id="dropdown-1"
                      class="m-md-2 text-capitalize"
                      variant="primary"
                      size="sm"
                      right
                    >
                      <template v-slot:button-content>
                        <font-awesome-icon icon="copy" />
                      </template>
                      <b-dropdown-item
                        v-if="hasFeatures('edit_obat')"
                        :to="{
                          name: 'klinik-obat-edit',
                          params: {
                            id: data.item.id
                          }
                        }"
                      >
                        Edit Data
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="hasFeatures('delete_obat')"
                        @click="
                          deleteObat({
                            id: data.item.id,
                            nama: data.item.nama_layanan
                          })
                        "
                      >
                        Hapus Data
                      </b-dropdown-item>
                    </b-dropdown>
                  </span>
                </template>
              </b-table>
            </DataTableWrapper>
          </b-col>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { union } from "lodash";
import startCase from "lodash/startCase";
import debounce from "lodash/debounce";
import { accounting } from "accounting";

import {
  faCopy,
  faDownload,
  faUpload
} from "@fortawesome/free-solid-svg-icons";

library.add(faCopy, faUpload, faDownload);
// import Multiselect from "vue-multiselect";

export default {
  components: {
    // Multiselect,
    DataTableWrapper: () => import("../../components/DataTableWrapper")
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      fromPage: 0,
      toPage: 0,
      totalEntries: 0,
      sortBy: "",
      sortDesc: false,
      searchValue: [],

      fieldList: [],

      obatList: [],

      selectedAll: false,
      isSelectedAll: false,
      currentPageChange: false,
      selectedId: []
    };
  },
  created() {
    // Initialize fieldList based on Satu Sehat bridging status
    this.initializeFieldList();
    
    if (this.hasFeatures("edit_obat")) {
      this.fieldList.unshift({
        key: "id",
        thStyle: "width: 4%",
        searchable: false
      });
      this.fieldList.push({
        key: "action",
        label: "action",
        thStyle: "width: 6%",
        searchable: false
      });
    }
  },
  computed: {
    ...mapGetters(["getKlinikId", "getRolesName", "satusehatAuthValid"])
  },

  watch: {
    selectedAll(val) {
      const { perPage, selectedId, obatList } = this;

      let selectedByUser = [...obatList].splice(0, perPage).map(obat => {
        return obat.id;
      });

      if (!val && !this.currentPageChange && this.isSelectedAll) {
        this.selectedId = this.selectedId.filter(
          item => selectedByUser.indexOf(item) < 0
        );
      }

      if (val && this.isSelectedAll) {
        let mergeArray = selectedId.concat(selectedByUser);
        this.selectedId =
          this.selectedId.length > 0
            ? union(mergeArray, selectedId)
            : mergeArray;
      }
      this.isSelectedAll = false;
      this.currentPageChange = false;
    },
    selectedId() {
      this.activePageSelectedAll();
    },
    currentPage(val) {
      this.selectedAll = false;
      this.fetchListObat();
    },
    perPage() {
      this.fetchListObat();
    },
    sortBy() {
      this.fetchListObat();
    },
    sortDesc() {
      this.fetchListObat();
    },

    searchValue: {
      handler: "fetchListObat",
      deep: true
    }
  },
  methods: {
    initializeFieldList() {
      // Base fields that are always present
      this.fieldList = [
        {
          key: "kode_layanan",
          label: "Kode Obat",
          thStyle: "width: 10%",
          searchable: true,
          sortable: true
        },
        {
          key: "nama_layanan",
          label: "nama obat",
          thStyle: "width:20%",
          searchable: true,
          sortable: true
        },
        {
          key: "satuan",
          label: "Satuan",
          thStyle: "width: 8%",
          searchable: true,
          sortable: true
        },
        {
          key: "stok",
          label: "Stok",
          thStyle: "width: 8%",
          searchable: true,
          sortable: true
        },
        {
          key: "tarif",
          label: "Harga Jual",
          thStyle: "width: 10%",
          searchable: true,
          sortable: true
        },
      ];

      // Add KFA Code and Bentuk Sediaan fields only if Satu Sehat is bridged
      if (this.satusehatAuthValid) {
        // Insert Kode KFA after Kode Obat
        this.fieldList.splice(1, 0, {
          key: "kfa_code",
          label: "Kode KFA",
          thStyle: "width: 10%",
          searchable: true,
          sortable: true
        });

        // Insert Bentuk Sediaan after nama obat
        this.fieldList.splice(3, 0, {
          key: "bentuk_sediaan",
          label: "Bentuk Sediaan",
          thStyle: "width: 12%",
          searchable: true,
          sortable: true
        });
      }
    },
    activePageSelectedAll() {
      let activeObat = this.obatList.map(item => item.id);
      let allObatSelected = this.selectedId.filter(
        item => activeObat.indexOf(item) >= 0
      );
      if (activeObat.length == allObatSelected.length) this.selectedAll = true;
      else this.selectedAll = false;
    },
    clearKategori(data) {
      if (data == null) {
        this.fetchListObat();
      }
    },
    clearJenis(data) {
      if (data == null) {
        this.fetchListObat();
      }
    },
    hasFeatures(value) {
      const features = {
        tambah_obat: ["pic_cabang", "apoteker"],
        edit_obat: ["pic_cabang", "apoteker"],
        delete_obat: ["pic_cabang", "apoteker"],
        upload: ["pic_cabang", "apoteker"],
        download: ["pic_cabang", "apoteker"]
      };

      const isOwner = features[value].filter(feature => {
        return this.getRolesName.includes(feature);
      });
      return isOwner.length > 0 ? true : false;
    },
    async fetchListObat() {
      let response = await this.$axios.get(
        `klinik/obat?klinik_id=${this.getKlinikId}&limit=${
          this.perPage
        }&page=${this.currentPage}${this.determineParameter()}`
      );
      const { status, data } = response;

      if (status) {
        const {
          data: obatList,
          total: totalEntries,
          to: toPage,
          from: fromPage
        } = data.data;

        this.obatList = obatList;
        this.rows = totalEntries || 0;
        this.toPage = toPage || 0;
        this.fromPage = fromPage || 0;
        this.totalEntries = totalEntries;

        return this;
      }
    },
    deleteObat({ id, nama = null }) {
      this.$swal({
        text: `Apakah anda yakin akan menghapus data obat ${nama} ?`,
        type: "question",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        const { value } = res;
        if (value) {
          try {
            const res = this.$axios
              .delete(
                `klinik/obat/${id}?klinik_id=${this.getKlinikId}`
              )
              .then(res => {
                const { status, data, message } = res.data;
                if (status) {
                  this.fetchListObat();
                  this.$swal({
                    type: "success",
                    title: startCase("sukses hapus obat"),
                    text: startCase("Data Obat berhasil di hapus")
                  });
                } else {
                  this.$swal({
                    text: message,
                    type: "warning"
                  });
                }
              });
          } catch (err) {
          }
        }
      });
    },
    // SETTING TABLE
    handleValueChanged({ perPage, currentPage }) {
      perPage && (perPage |> (_ => (this.perPage = _)));
      currentPage && (currentPage |> (_ => (this.currentPage = _)));
    },
    searchValueChanged: debounce(function(val, key) {
      const { searchValue } = this;

      const z = searchValue.filter(item => item.key !== key);

      this.searchValue = [
        ...z,
        {
          key,
          value: val
        }
      ];
    }, 500),
    determineParameter() {
      const { searchValue, sortBy, sortDesc } = this;
      let v = "";

      searchValue.map(item => {
        const x = item.key;
        v += `&${x}=${item.value}`;
      });

      if (sortBy) {
        v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
      }

      return v;
    },

    async downloadOBAT() {
      const payload = {
        klinik_id: this.getKlinikId,
        id: this.selectedId
      };
      const res = await this.$axios.post(`klinik/obat/export`, payload);
      const { status, data } = res.data;
      if (status) {
        let link = document.createElement("a");
        link.href = data.link;
        link.setAttribute("download", data.name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.selectedId = [];
      } else {
        this.$swal({
          text: "Something went wrong",
          type: "error"
        });
      }
    },
    goUpload() {
      this.$store.commit("SET_UPLOAD_OBAT", null);
      this.$router.push({
        name: "klinik-obat-upload"
      });
    }
  },
  filters: {
    currency: function(value) {
      return accounting.formatColumn([value], "", 0, ".")[0]
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.multiselect {
  &.__multi-select-tarif {
    min-height: auto !important;
    font-size: 12px !important;
    height: 31px !important;
    & > .multiselect__select {
      margin-top: -6px;
    }
    & > .multiselect__tags {
      height: 31px !important;
      min-height: 31px !important;
      padding: 2px 30px 0 6px;
    }
  }
}
</style>

<style lang="css">
.f10 {
  font-size: 10px !important;
}

.bg-cst-box {
  background: #fff;
  border: 1px solid #cdcdcd;
  width: 30px;
  margin: 15px auto;
  height: 30px;
  border-radius: 8px;
}

.cst-cbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: none !important;
}

.cst-cbox .custom-control-input:checked ~ .custom-control-label::before,
.cst-cbox .custom-control-input:checked ~ .custom-control-label::after {
  color: #fff;
  border-color: #cdcdcd;
  background-color: #6b6b72;
}

.cst-cbox .custom-control-label::before,
.cst-cbox .custom-control-label::after {
  border-radius: 4px;
  margin-top: 2px;
  margin-left: 3.2px;
}

.layout-gantung {
  border-radius: 0px 0px 10px 10px;
  max-height: 250px;
}

.ninja-shadow {
  box-shadow: 0px 8px 15px 0px lightgrey;
}

#obat-klinik .__zoom_display {
  zoom: 80%;
}
</style>
